<template>
  <b-container class="custom-card">
    <LoadingIndicator 
      v-if="loading"
      topic="Survey Results"
    />
    <div v-else>
      <h1>Survey Results - {{ surveyName }}</h1>
      <SurveyResults
        :projectId="projectId"
        :periods="periods"
        :selectedPeriod="periodName"
        :chartData="byQuestionData"
        :allProjectUsers="projectUsers"
        :allowReminding="false"
        :showComments="false"
        :showRespondants="false"
        @update="updateByQuestion"
      ></SurveyResults>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import authMixin from '@/mixins/auth-mixin.js';
import SurveyResults from "@/components/survey/SurveyResults.vue";

export default {
  name: "SurveyResultsPage",
  components: {
    SurveyResults,
  },
  mixins: [
    authMixin
  ],
  data() {
    return {
      surveyId: "",
      surveyName: "",
      projectId: "",
      periods: [],
      periodName: "",
      byQuestionData: [],
      projectUsers: [],
      loading: false,
      errors: [],
    };
  },
  mounted() {
    this.loading = true;
    let surveyId = this.$route.params.id;
    let status = this.$route.query.status;
    let userId = this.$route.query.uid;

    if (!surveyId) {
      this.defaultRedirect();
      return;
    }

    if (this.authenticated) {
      this.loadSurveyResults(surveyId);
      return;
    } 
    
    if (!status || !userId) {
      this.defaultRedirect();
    }

    let route;
    if (status == 'NoPassword') {
      route = { name: 'Sign Up', query: { uid: userId, sid: surveyId } }
    } else if (status === 'NotSetup') {
      route = { name: 'Account Setup', query: { uid: userId, sid: surveyId } }
    } else {
      route = {
        name: 'Login', 
        query: { 
          returnUrl: `/evaluation/${surveyId}/results`, 
          message: 'Please log in to see survey results' 
        } 
      } 
    }

    this.$router.push(route);
  },
  methods: {
    updateByQuestion(update) {
      //Surveys by question
      this.periodName = update.period;
      let url = `${this.$api_url}/surveys/${this.surveyId}/data-by-question?period=${update.period}`;
      axios
        .get(url, this.getReqConfig())
        .then((response) => {
          this.byQuestionData = this.$helpers.mapDataPointToChartDataSet(
            response.data
          );
        })
        .catch((err) => {
          if (err.response && err.response.statusText) {
            this.errors.push({ message: err.response.statusText });
          } else {
            this.errors.push(err);
          }
        });

      //Respondent list
      url = `${this.$api_url}/projects/${this.projectId}/users?periodId=${update.period}&inactiveUsers=true`;
      axios
        .get(url, this.getReqConfig())
        .then((response) => {
          this.projectUsers = response.data;
        })
        .catch((err) => {
          if (err.response && err.response.statusText) {
            this.errors.push({ message: err.response.statusText });
          } else {
            this.errors.push(err);
          }
        });
    },
    loadSurveyResults(surveyId){
      axios
        .get(`${this.$api_url}/surveys/${surveyId}/results`, this.getReqConfig())
        .then((response) => {
          this.surveyId = surveyId;
          this.projectId = response.data.survey.projectId;
          this.periods = response.data.periods;
          this.periodName =  response.data.periods.length > 0 ? response.data.periods[response.data.periods.length - 1].periodName : "";
          this.byQuestionData = this.$helpers.mapDataPointToChartDataSet(
            response.data.responsesByQuestion
          );
          this.surveyName = response.data.survey.surveyName;
          this.projectUsers = response.data.projectUsers;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>